import myPositionActions from "../../../actions/myPositionActions";
import myPositionTableColumns, {
  myPositionTableLeftFixedColumns,
  myPositionTableSummaries,
} from "./myPositionTableColumns";
import generateEntityTable from "../../../hocs/generateEntityTable";

const MyPositionsTable = generateEntityTable({
  entityPluralString: "myClientPositions",
  entityActions: myPositionActions,
  columns: myPositionTableColumns,
  leftFixedColumns: myPositionTableLeftFixedColumns,
  operations: [],
  summaries: myPositionTableSummaries,
  // walletBalancingOperation: true,
  // walletBalancingRoutePath: "/client-wallet-balancing/:id",
});

export default MyPositionsTable;
